export const formatDate = (dateString: string | Date | null | undefined): string => {
  if (!dateString) return 'N/A';
  
  try {
    // Handle ISO strings, timestamps, and Date objects
    let date: Date;
    
    if (typeof dateString === 'string') {
      // Try to parse the date string
      date = new Date(dateString);
      
      // If it's not a valid date, log and return N/A
      if (isNaN(date.getTime())) {
        
        return 'N/A';
      }
    } else {
      date = dateString;
    }
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      
      return 'N/A';
    }
    
    // Format date in UK format (DD MMM YYYY, HH:MM)
    return new Intl.DateTimeFormat('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  } catch (error) {
    
    return 'N/A';
  }
};

export const formatDOB = (date: string | Date | null | undefined): string => {
  if (!date) return '';
  const dobDate = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(dobDate);
};
